import { GuestLayout } from './Guest';
import { VerifiedLayout } from './Verified';

export {
  GuestLayout,
  VerifiedLayout
}